import { Cat, Dog, Rabbit, Bird, Fish, Rocket, Star, Ghost, Turtle, Squirrel, Palette, Music, Sparkles, FlaskConical, BookOpen, Blocks, PawPrint, Laugh } from "lucide-react";

export const AVATARS = { cat: Cat, dog: Dog, rabbit: Rabbit, bird: Bird, fish: Fish, rocket: Rocket, star: Star, ghost: Ghost, turtle: Turtle, squirrel: Squirrel };

export const COLORS = ["#FF6B4A", "#FFD23F", "#3DCCC7", "#7B5CFA", "#FF8FC7", "#B8F2C9"];

export const CATEGORIES = [
  { id: "art", label: "Art", icon: Palette, color: "#FF8FC7" },
  { id: "music", label: "Music", icon: Music, color: "#7B5CFA" },
  { id: "dance", label: "Dance", icon: Sparkles, color: "#FFD23F" },
  { id: "science", label: "Science", icon: FlaskConical, color: "#3DCCC7" },
  { id: "stories", label: "Stories", icon: BookOpen, color: "#FF6B4A" },
  { id: "builds", label: "Builds", icon: Blocks, color: "#B8F2C9" },
  { id: "pets", label: "Pets", icon: PawPrint, color: "#FFB86B" },
  { id: "comedy", label: "Comedy", icon: Laugh, color: "#9BD0FF" },
];

export const catById = (id) => CATEGORIES.find((c) => c.id === id) || CATEGORIES[0];

export const timeAgo = (iso) => {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
